import React, { useEffect, useRef, useState } from "react";
import Close from './../assets/images/close_icon.svg'
import InputFields from "../components/InputFields";
import { useAddMenu, useGetAllCategory, useUpdateMenu } from './../hooks/hooks';
import { showErrorToast, showSuccessToast } from './../components/common'
import { useTranslation } from "react-i18next";

const AddMenu = ({ isOpen, onClose, isEdit, isEditItem }) => {
    const { t } = useTranslation();
    const { data: categoryList } = useGetAllCategory();


    const [inputValue, setInputValue] = useState({ name: "", isActive: true, categoryId: "" });
    const [Error, setError] = useState({ name: "", isActive: true, categoryId: "" });
    const { mutate: addMenu } = useAddMenu();
    const { mutate: updateMenu } = useUpdateMenu();

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isEdit && isEditItem) {
            setInputValue({
                name: isEditItem.menuName || "",
                isActive: isEditItem.isActive || true,
                categoryId: isEditItem?.category?._id || "",
            });
        }
    }, [isEdit, isEditItem]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.toString(),
        });
        setError({ ...Error, name: "", isActive: true, categoryId: '', all: "" });
    };

    const onSubmit = () => {
        if (inputValue.name.toString().trim() === "") {
            setError({ ...Error, name: t('Menu_Name_Er') });
            return;
        }

        if (inputValue.categoryId === "") {
            setError({ ...Error, categoryId: t('Select_Category_Er') });
            return;
        }

        setIsLoading(true);

        if (isEdit) {
            const updateItem = {
                name: inputValue.name,
                isActive: inputValue.isActive,
                categoryId: inputValue.categoryId,
                _id: isEditItem._id
            }
            updateMenu(updateItem, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    onClose(true);
                    setIsLoading(false);
                    setError({ ...Error, name: "", isActive: true, categoryId: '', all: "" });
                },
                onError: (err) => {
                    setIsLoading(false);
                    setError({ ...Error, all: err.response.data.error });
                },
            });
        } else {
            addMenu(inputValue, {
                onSuccess: (res) => {
                    showSuccessToast(res?.data?.message);
                    onClose(true);
                    setIsLoading(false);
                    setError({ ...Error, name: '' });
                },
                onError: (err) => {
                    setIsLoading(false);
                    showErrorToast(err.response.data.error);
                    setError({ ...Error, all: err.response.data.error });
                },
            });

        }
    }

    return (
        <>
            {isOpen && (
                <div className="popup-overlay ">
                    <div
                        className="popup-content !w-[447px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-center items-center text-[16px] font-semibold text-secondary relative">
                            {isEdit ? t('um_title') : t('am_title')}
                            <div
                                className="right-[0px] absolute cursor-pointer hover:bg-[#08665624] hover:rounded-[20px] w-[30px] h-[30px] flex items-center justify-center"
                                onClick={() => {
                                    onClose(false);
                                    setError({ name: "", isActive: true });
                                }}
                            >
                                <img src={Close} alt="" />
                            </div>
                        </div>

                        <hr className="h-[1px] mt-[14px] bg-[#EAEAFF]"></hr>

                        <div className="p-[10px]">
                            <div className="mt-[20px]">
                                <label className="font-medium text-[14px] text-[#6F6F6F] mb-[6px]">
                                    Category
                                </label>

                                <div className="relative">
                                    <select
                                        name="categoryId"
                                        value={inputValue.categoryId}
                                        onChange={handleChange}
                                        className="text-input mt-[5px] w-full h-[50px] px-[19px] text-[16px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5] appearance-none focus:outline-none focus:ring-0  cursor-pointer">
                                        <option value="" disabled selected>{t('select_options')}</option>
                                        {categoryList && categoryList.map((category) => (
                                            <option key={category._id} value={category._id}>
                                                {category.categoryName}
                                            </option>
                                        ))}
                                    </select>
                                    {/* Icon */}
                                    <svg
                                        className="absolute top-1/2 right-[15px] transform -translate-y-1/2 pointer-events-none"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M4.293 6.293a1 1 0 011.414 0L8 8.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                            fill="#6F6F6F"
                                        />
                                    </svg>
                                </div>

                                {Error?.categoryId && <div className='text-red-500  text-[14px]'>{Error?.categoryId}</div>}
                            </div>


                            <div className="mt-[20px]">
                                <label className="font-medium text-[14px] text-[#6F6F6F] mb-[6px]">
                                    {t('menu_name')}
                                </label>
                                <InputFields
                                    name="name"
                                    label="menu name"
                                    type="text"
                                    placeholder={t('pl_menu_name')}
                                    isHideLabel="false"
                                    isFixedLabel="true"
                                    disabled={isLoading}
                                    handleChange={(e) => handleChange(e)}
                                    value={inputValue?.name}
                                    className="text-input mt-[5px] w-full h-[50px] px-[19px] text-[16px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]"
                                />
                                {Error?.name && <div className='text-red-500  text-[14px]'>{Error?.name}</div>}
                            </div>


                            {Error?.all && <div className='text-red-500  text-[14px]'>{Error?.all}</div>}

                            <button
                                className="mt-[40px]  w-full h-[52px] rounded-[26px] bg-secondary text-[15px] font-[600] text-white"
                                onClick={onSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <svg
                                        aria-hidden="true"
                                        role="status"
                                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                                        viewBox="0 0 100 101"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                            fill="#E5E7EB"
                                        />
                                        <path
                                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                ) : (
                                    <>
                                        {isEdit ? t('btnUpdate') : t('btnSave')}
                                    </>

                                )}
                            </button>

                        </div>

                    </div>

                </div>
            )}
        </>
    )
}

export default AddMenu;
